import { featureTopic } from "@/mocks/homeData";

export default function FeatureTopic() {
  return (
    <section className="bg-background-50 py-14 md:py-24">
      <div className="px-4 md:px-10 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-2 text-primary-600 text-xs md:text-sm tracking-[0.2em] uppercase">
            <span className="w-6 h-px bg-primary-500"></span>
            {featureTopic.badge}
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            {featureTopic.title}
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            {featureTopic.summary}
          </p>
          <ul className="mt-7 space-y-3">
            {featureTopic.points.map((point) => (
              <li key={point} className="flex items-start gap-3 text-sm md:text-base text-foreground-800">
                <span className="w-5 h-5 mt-0.5 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-check-line text-xs"></i>
                </span>
                {point}
              </li>
            ))}
          </ul>
        </div>

        <div className="order-1 lg:order-2 w-full h-[280px] md:h-[400px] rounded-lg overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=stylized%20empty%20stage%20with%20warm%20spotlight%2C%20crimson%20curtain%2C%20abstract%20minimal%2C%20no%20people%2C%20editorial%20photography%2C%20dark%20moody%20background%2C%20subtle%20grain&width=1100&height=820&seq=heiliaoyiqu-feature-01&orientation=landscape"
            alt="黑料一区 本周封面话题 吃瓜热帖现场"
            title="黑料一区 热门瓜 本周封面话题"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}